import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

type CharterPurchaseComplete = {};

function CharterPurchaseComplete({}: CharterPurchaseComplete) {
  const { t } = useTranslation(
    "client\\components\\enrolling\\CharterPurchaseComplete",
  );

  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        alignItems: "flex-start",
        marginBottom: "1em",
      }}
    >
      <Typography variant="h3">{t("Payment complete")}</Typography>
      {t(
        "You will receive an email receipt. The parent will receive an enrollment confirmation and all other communication about the class.",
      )}
    </Box>
  );
}

export default CharterPurchaseComplete;
